// 本地数据存储：八字档案 CRUD + 激活档案（IndexedDB，回退 localStorage）
import { get, set } from 'idb-keyval'
import type { BirthProfile } from './lib/bazi'

const PROFILES_KEY = 'dayi.profiles'
const ACTIVE_KEY = 'dayi.activeProfileId'

function loadLS<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as T) : null
  } catch {
    return null
  }
}

function saveLS(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    /* quota exceeded — ignore */
  }
}

export async function loadProfiles(): Promise<BirthProfile[]> {
  try {
    const v = await get<BirthProfile[]>(PROFILES_KEY)
    if (Array.isArray(v)) return v
  } catch {
    /* fall through */
  }
  return loadLS<BirthProfile[]>(PROFILES_KEY) ?? []
}

export async function persistProfiles(profiles: BirthProfile[]): Promise<void> {
  saveLS(PROFILES_KEY, profiles)
  try {
    await set(PROFILES_KEY, profiles)
  } catch {
    /* ignore */
  }
}

export async function loadActiveId(profiles: BirthProfile[]): Promise<string | null> {
  try {
    const v = await get<string>(ACTIVE_KEY)
    if (v && profiles.some((p) => p.id === v)) return v
  } catch {
    /* fall through */
  }
  const ls = loadLS<string>(ACTIVE_KEY)
  if (ls && profiles.some((p) => p.id === ls)) return ls
  return profiles.length ? profiles[0].id : null
}

export async function persistActiveId(id: string): Promise<void> {
  saveLS(ACTIVE_KEY, id)
  try {
    await set(ACTIVE_KEY, id)
  } catch {
    /* ignore */
  }
}

export function uid(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`
}